import React from 'react';
import { CarrierListTemplate } from 'themes/modules/carrier/pages';
import { CarrierListViewStore } from 'modules/carrier/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new CarrierListViewStore(rootStore), 'carrierListViewStore')
class CarrierList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <CarrierListTemplate {...this.props} viewStore={this.props.carrierListViewStore} />;
	}
}

export default CarrierList;
